// src/app/reports/reportDefinitions.ts

export type ReportSectionDefinition = {
  title?: string;
  columns?: {
    key: string;
    label: string;
    align?: "left" | "right" | "center";
  }[];
};

export const reportSectionDefinitions: Record<string, ReportSectionDefinition> = {
  budgetByCostCenter: {
    title: "Budget par centre de coûts",
    columns: [
      { key: "costCenterCode", label: "Code" },
      { key: "costCenterName", label: "Centre de coûts" },
      { key: "budgetFormatted", label: "Budget", align: "right" },
    ],
  },

  budgetByAccountGroup: {
    title: "Budget par groupe de comptes",
    columns: [
      { key: "groupCode", label: "Groupe" },
      { key: "budgetFormatted", label: "Budget", align: "right" },
    ],
  },

  budgetByAccount: {
    title: "Budget par compte",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Libellé" },
      { key: "budgetFormatted", label: "Budget", align: "right" },
    ],
  },

  adoptedVsRevised: {
    title: "Budget adopté vs révisé",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Libellé" },
      { key: "adoptedAmount", label: "Adopté", align: "right" },
      { key: "revisedAmount", label: "Révisé", align: "right" },
      { key: "deltaFormatted", label: "Écart", align: "right" },
    ],
  },

  executionByCostCenter: {
    title: "Exécution par centre de coûts",
    columns: [
      { key: "costCenterCode", label: "Code" },
      { key: "costCenterName", label: "Centre de coûts" },
      { key: "budgetAmount", label: "Budget", align: "right" },
      { key: "actualAmount", label: "Réalisé", align: "right" },
      { key: "varianceAmount", label: "Écart", align: "right" },
      { key: "executionPct", label: "Exécution %", align: "right" },
    ],
  },

  executionByAccount: {
    title: "Exécution par compte",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Libellé" },
      { key: "budgetAmount", label: "Budget", align: "right" },
      { key: "actualAmount", label: "Réalisé", align: "right" },
      { key: "varianceAmount", label: "Écart", align: "right" },
      { key: "executionPct", label: "Exécution %", align: "right" },
    ],
  },

  criticalVariance: {
    title: "Écarts critiques",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Libellé" },
      { key: "costCenterCode", label: "Centre" },
      { key: "varianceAmount", label: "Écart", align: "right" },
      { key: "variancePct", label: "Écart %", align: "right" },
    ],
  },

  activityDetail: {
    title: "Détail des activités",
    columns: [
      { key: "activityCode", label: "Code" },
      { key: "activityName", label: "Activité" },
      { key: "costCenterCode", label: "Centre" },
      { key: "plannedFormatted", label: "Planifié", align: "right" },
      { key: "actualFormatted", label: "Réalisé", align: "right" },
      { key: "progressPct", label: "Progression %", align: "right" },
    ],
  },

  kpiDetail: {
    title: "Détail des KPI",
    columns: [
      { key: "kpiCode", label: "Code" },
      { key: "kpiName", label: "KPI" },
      { key: "costCenterCode", label: "Centre" },
      { key: "targetValue", label: "Cible", align: "right" },
      { key: "actualValue", label: "Réalisé", align: "right" },
      { key: "actualPct", label: "Score %", align: "right" },
    ],
  },
};